var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class SportParser {
    constructor(retrievers, messageBus, channelPrefix) {
        this.subscription = () => { };
        this.messageBus = messageBus;
        this.retrievers = retrievers;
        this.channelPrefix = channelPrefix;
        this.isActive = false;
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isActive = true;
            this.subscription = this.messageBus.getSubscription(this.getCountUpdateChannel(), (message) => this.updateSelectedItemCount(state, message.data[0]), this);
            yield Promise.all(this.retrievers.map((r) => __awaiter(this, void 0, void 0, function* () {
                return yield r.activate(state);
            })));
            if (this.isActive) {
                state.selectInitial();
            }
        });
    }
    deactivate() {
        this.isActive = false;
        this.retrievers.forEach(r => r.deactivate());
        this.subscription();
    }
    getCountUpdateChannel() {
        return `${this.channelPrefix}.${InternalMessageBusChannels.eventsList.count}`;
    }
    updateSelectedItemCount(state, message) {
        if (state.SelectedItemId !== message.sportId) {
            return;
        }
        const eventCount = message.eventsCount;
        if (eventCount > 0) {
            state.update(state.SelectedItemId, { numberOfEvents: eventCount }, true);
        }
        else {
            state.remove(state.SelectedItemId, true);
        }
    }
}
//# sourceMappingURL=SportParser.js.map